import { render, staticRenderFns } from "./TeamRequestsDetailManagerPage.vue?vue&type=template&id=d7d4bdb6"
import script from "./TeamRequestsDetailManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsDetailManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d4bdb6')) {
      api.createRecord('d7d4bdb6', component.options)
    } else {
      api.reload('d7d4bdb6', component.options)
    }
    module.hot.accept("./TeamRequestsDetailManagerPage.vue?vue&type=template&id=d7d4bdb6", function () {
      api.rerender('d7d4bdb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/manager/team-requests-detail/TeamRequestsDetailManagerPage.vue"
export default component.exports